/** Floor value to prevent log(0) in logarithmic positioning */
export const WHISKER_CHART_LOG_FLOOR = 0.01;
/** When within this many points of max, boost the "You" marker toward the bar end */
export const WHISKER_CHART_CLOSE_THRESHOLD = 25;
